import { useEffect } from "react";
import { SiteNav, SiteFooter } from "../components/SiteChrome";
import { trackPageView } from "../lib/analytics";
import "../styles/site.css";

export default function Terms() {
  useEffect(() => {
    document.title = "C-STYL — Terms of Service";
    window.scrollTo(0, 0);
    trackPageView();
  }, []);

  return (
    <div className="site" data-testid="terms-page">
      <SiteNav />

      <div className="doc">
        <h1 className="serif">Terms of Service</h1>
        <p style={{ color: "#8b857c" }}>Last updated: June 2026</p>
        <p>Welcome to C-STYL. By using the app you agree to these Terms.</p>

        <h2>Using the app</h2>
        <p>C-STYL provides AI-assisted outfit recommendations and virtual try-on for personal, non-commercial use. You are responsible for the content (photos) you add and for keeping your account secure.</p>

        <h2>AI-generated content</h2>
        <p>Outfit suggestions and try-on images are AI visualizations and may differ from real garments. They are provided “as is” for guidance and inspiration.</p>

        <h2>Acceptable use</h2>
        <p>Do not upload unlawful content or content you do not have the right to use, and do not attempt to disrupt or reverse-engineer the service.</p>

        <h2>Accounts &amp; termination</h2>
        <p>You may delete your account at any time from Profile. We may suspend accounts that violate these Terms.</p>

        <h2>Disclaimer &amp; liability</h2>
        <p>The service is provided without warranties of any kind. To the maximum extent permitted by law, C-STYL is not liable for any indirect or incidental damages arising from use of the app.</p>

        <h2>Changes</h2>
        <p>We may update these Terms from time to time; continued use means you accept the updated Terms.</p>

        <h2>Contact</h2>
        <p>Questions? Email <a href="mailto:support@c-styl.com" style={{ color: "#C8A24C" }}>support@c-styl.com</a>.</p>
      </div>

      <SiteFooter />
    </div>
  );
}
